import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import { Button } from '@mui/material';

import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleContent,
} from '@/components/shared/toggle-button-group';
import { useWizard } from '@/context/wizard';
import { ResourceTypes } from '@/models/resources';
import type { RefundRequestWizardProps } from '@/packages/subsidy/pages/refund-request/steps/resource-description/interfaces';
import { useRefundRequestNavigation } from '@/packages/subsidy/pages/refund-request/steps/resource-description/navigation/use-navigation';
import { RefundRequestWizardStepIds } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/step-ids';

const resourceTypeOptions = [
  {
    value: ResourceTypes.Course,
    label: 'Cursos',
    icon: <SchoolOutlined sx={{ fontSize: 32, color: 'primary.dark' }} />,
  },
  {
    value: ResourceTypes.Book,
    label: 'Livros',
    icon: <MenuBookOutlined sx={{ fontSize: 32, color: 'primary.dark' }} />,
  },
  {
    value: ResourceTypes.EventOrLecture,
    label: 'Eventos e Palestras',
    icon: <PeopleOutlined sx={{ fontSize: 32, color: 'primary.dark' }} />,
  },
  {
    value: ResourceTypes.Others,
    label: 'Outros',
    icon: <DescriptionOutlined sx={{ fontSize: 32, color: 'primary.dark' }} />,
  },
];

const stepId = RefundRequestWizardStepIds.ExternalResourceType;

type ExternalResourceTypeValue = RefundRequestWizardProps[typeof stepId];

export const ExternalItemType = () => {
  const { values } = useWizard<RefundRequestWizardProps>();
  const { canGoBack, handleBack, handleNext } = useRefundRequestNavigation({
    stepId,
  });

  const currentValue = values[stepId];

  const eligibleExternalResourceKinds =
    values.selectedPolicy?.configuration?.eligible_external_resource_kinds;

  const visibleResourceTypeOptions = eligibleExternalResourceKinds?.length
    ? resourceTypeOptions.filter(({ value }) =>
        eligibleExternalResourceKinds.includes(value)
      )
    : resourceTypeOptions;

  const handleOnChange = (value: ExternalResourceTypeValue) => {
    const updatedValues: Partial<RefundRequestWizardProps> = {
      [stepId]: value,
    };

    if (value !== currentValue) {
      updatedValues[RefundRequestWizardStepIds.ExternalItemForm] = {
        course: null,
        learningAid: null,
      };
    }

    handleNext(updatedValues);
  };

  return (
    <div>
      <ToggleButtonGroup<ExternalResourceTypeValue>
        value={values[stepId]}
        onChange={handleOnChange}
        aria-label="Selecione o tipo de item"
        direction={{ md: 'row' }}
        sx={{ mb: 2 }}
      >
        {visibleResourceTypeOptions.map(({ value, label, icon }) => (
          <ToggleButton key={value} value={value}>
            <ToggleContent icon={icon} title={label} />
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {canGoBack && <Button onClick={handleBack}>Voltar</Button>}
    </div>
  );
};
